import { NavigationWrapper } from '../../components/navigation/NavigationWrapper';
import {
  ActionIcon,
  Avatar,
  Group,
  Drawer,
  Paper,
  Stack,
  Title,
  Checkbox,
  Button,
  Space,
  Text,
} from '@mantine/core';
import { useApp } from '../../context/AppContext';

import { primaryColor } from '../../constants/theme';
import { RenderFilterOptions } from './components/search/FilterOptions';
import { FilterModal } from './components/search/FilterDrawer';
import { SearchResultsStack } from './components/search/SearchResultsStack';
import { SearchProvider, useSearch } from './components/search/SearchContext';

interface SearchResultsPageProps {
  hideFilters?: boolean;
  overrideSearchWith?: number;
}

export const SearchResultsPage = ({
  hideFilters,
  overrideSearchWith,
}: SearchResultsPageProps) => {
  return (
    <NavigationWrapper>
      <SearchProvider>
        <SearchWithFilters
          hideFilters={hideFilters}
          overrideSearchWith={overrideSearchWith}
        />
      </SearchProvider>
    </NavigationWrapper>
  );
};

const SearchWithFilters = ({
  hideFilters,
  overrideSearchWith,
}: SearchResultsPageProps) => {
  const { isTabletAndBelow, scrollAreaHeight } = useApp();
  const {
    searchResults,
    filtersOpen,
    setFiltersOpen,
    resetFilters,
    filterCount,
  } = useSearch();

  return (
    <>
      <FilterModal
        facets={searchResults?.facets}
        onClose={() => setFiltersOpen(false)}
        opened={filtersOpen}
      />
      <Group gap="md" align="flex-start" justify="center">
        <Paper
          shadow="xl"
          maw={overrideSearchWith ?? 900}
          radius="md"
          bg="white"
          flex={1}
          mih={isTabletAndBelow ? scrollAreaHeight : undefined}
        >
          <SearchResultsStack />
        </Paper>
        {!isTabletAndBelow && !hideFilters && (
          <Paper
            shadow="xl"
            maw="300px"
            radius="md"
            bg="white"
            mih={800}
            flex={1}
          >
            <Stack p={'md'}>
              <Group justify="space-between">
                <Group gap={5}>
                  <Title order={3} fw="normal">
                    Filters
                  </Title>
                  <Text c={primaryColor}>({filterCount})</Text>
                </Group>
                <Button
                  disabled={filterCount === 0}
                  variant="transparent"
                  color={primaryColor}
                  p={1}
                  onClick={resetFilters}
                >
                  RESET
                </Button>
              </Group>
              <RenderFilterOptions facets={searchResults?.facets} />
            </Stack>
          </Paper>
        )}
      </Group>
    </>
  );
};
